import { Component } from '@angular/core';

@Component({
  selector: 'app-hcm-shell-home',
  standalone: true,
  imports: [],
  templateUrl: './hcm-shell-home.component.html',
  styleUrl: './hcm-shell-home.component.css'
})
export class HcmShellHomeComponent {

}
